
import { Component, Prop, Mixins } from 'vue-property-decorator';
import {
  Dialog,
  Form,
  FormItem,
  Input,
  InputNumber,
  Select,
  Option,
  Button,
  Upload,
} from 'element-ui';
import { ISetting } from '@/types/set.d';
import api from '@/api/course';
import FormMixin from './formMixin';

@Component({
  components: {
    Dialog,
    Form,
    FormItem,
    Input,
    InputNumber,
    Select,
    Option,
    Button,
    Upload,
  },
})
export default class ManageBusModal extends Mixins(FormMixin) {
  @Prop({
    required: true,
    default: false,
  }) visible!: boolean;

  @Prop({
    required: false,
    default: '添加配置',
  }) title!: string;

  @Prop({
    required: false,
  }) oldForm!: any;

  private status: any = [{ label: '是', value: 0 }, { label: '否', value: 1 }];

  private courseSystemList: any = [{ label: '体系', value: 'FORMAL' }, { label: '非体系', value: 'INFORMAL' }]

  private fileListImg: any = [];

  private diffculites: any = [];

  mounted() {
    if (this.form.parentPid !== '1') this.form.parentPid = this.oldForm.parentId;
    if (this.title.includes('修改')) {
      this.form = {
        pid: this.oldForm.id,
        title: this.oldForm.title,
        visible: this.oldForm.visible,
        sort: this.oldForm.sort,
        parentPid: this.oldForm.parentId,
        classHour: this.oldForm.classHour,
        structure: this.oldForm.structure,
      };
      if (this.oldForm.iconPath) this.fileListImg = [{ url: this.oldForm.iconPath }];
    }
  }

  /**
   * @author lianguongmou
   * @desc 图片上传前事件
    */
  handleBeforeUpload(file: File) {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = (e:any) => {
      this.fileListImg = [{ url: e.target.result }];
    };
    this.form.iconFile = file;
    return false;
  }

  /**
   * @author liangyongmou
   * @desc 主图片删除事件
   * @params { any } file 文件
   */
  handleBeforeRemove(file: any) {
    if (file.status === 'success') this.form.stepImage = '';
  }

  // 重置表单
  reset(close: boolean = false, refrsh: boolean = false) {
    if (close) this.$emit('update:visible', false);
    if (refrsh) this.$emit('refrsh');
    this.$log({
      title: `${this.log.name}${close ? '关闭' : '重置'}`,
      component: this.log.component,
    });
    this.resetForm();
  }

  /**
   * @author liangyongmou
   * @desc 添加/编辑信息
   * @param { string } title 标题
   */
  submit(title: string) {
    this.loading = true;
    this.$refs.form.validate((valid: boolean) => {
      if (valid) {
        this.$log({
          title: `${this.log.name}提交`,
          component: this.log.component,
        });
        const data = new FormData();
        Object.keys(this.form).forEach((index) => {
          if (this.form[index] || this.form[index] === 0) data.append(index, this.form[index]);
        });
        if (title.includes('修改')) {
          api.editType(data).then(() => {
            this.reset(true, true);
            this.loading = false;
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        } else {
          api.addType(data).then(() => {
            this.reset(true, true);
            this.loading = false;
          /* eslint-disable no-return-assign */
          }).catch(() => (this.loading = false));
        }
      } else this.loading = false;
    });
  }
}
